/** CenterContainer registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCenterContainer } from './parser';
const centerContainerRegistration = {
    typeName: 'CenterContainer',
    parser: parseCenterContainer,
};
nodeRegistry.register(centerContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map